import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Link,
} from '@mui/material';
import { csAdminApi } from '../services/api';
const ForgotPassword = () => {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await csAdminApi.forgotPassword({ identifier: identifier.trim() });
      setSubmitted(true);
    } catch (err) {
      console.error('Forgot password error:', err);
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%)',
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <img
              src="/Etisalat_eand_Logo_EN_red.png"
              alt="Etisalat Logo"
              style={{ width: '100px', marginBottom: '16px' }}
            />
            <Typography variant="h4" component="h1" gutterBottom>
              Forgot Password
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Enter your username or work email. We will send reset instructions if an account exists.
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          {submitted ? (
            <Alert severity="success" sx={{ mb: 3 }}>
              If an account exists for that username or email, password reset instructions have been sent.
              Check your inbox and use the link to sign in with a temporary password, then set a new password.
            </Alert>
          ) : (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Username or email"
                name="identifier"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                margin="normal"
                required
                autoFocus
                disabled={loading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                disabled={loading || !identifier.trim()}
                sx={{ mt: 3, mb: 1 }}
              >
                {loading ? <CircularProgress size={24} /> : 'Send reset instructions'}
              </Button>
            </form>
          )}

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Link component={RouterLink} to="/login" variant="body2">
              Back to sign in
            </Link>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
